import { SearchInputStore } from 'ui/standard/input/search_input/search_input_store';
import { action, computed, observable } from 'mobx';
import { HistoryFilter, ProtocolFilter } from 'services/pangolin/types';
import {
  createProtocolFilterOptions,
  getProtocolFilterID,
} from 'ui/history/protocol_entry/protocol_entry_logic';
import { notUndefined } from 'ui/base/types';

import { PortInputStore } from './port_input_modal/port_input_store';
import { RangeInputStore } from './range_input_modal/range_input_store';

export class ProtocolInputStore {
  search: SearchInputStore;
  port: PortInputStore;
  range: RangeInputStore;

  @observable.shallow entries: ProtocolFilter[];
  @observable.shallow options: readonly ProtocolFilter[];

  constructor(filter: HistoryFilter) {
    this.search = new SearchInputStore();
    this.port = new PortInputStore();
    this.range = new RangeInputStore();

    const entries = filter.protocols;

    this.entries = entries;
    this.options = createProtocolFilterOptions(entries);
  }

  @action.bound
  commitEntry(entry: ProtocolFilter): void {
    this.entries.push(entry);
  }

  @action.bound
  removeEntry(entry: ProtocolFilter): void {
    const id = getProtocolFilterID(entry);
    const index = this.entries.findIndex(e => getProtocolFilterID(e) === id);
    if (index >= 0) {
      this.entries.splice(index, 1);
    }
  }

  @action.bound
  commitPort() {
    const entry = this.port.commit();
    if (entry == null) {
      return;
    }
    this.entries.push(entry);
    this.port.hideModal();
    this.search.modal.hideModal();
  }

  @action.bound
  commitRange() {
    const entry = this.range.commit();
    if (entry == null) {
      return;
    }
    this.entries.push(entry);
    this.range.hideModal();
    this.search.modal.hideModal();
  }

  @computed
  get protocolFilters(): ProtocolFilter[] {
    return this.entries.filter(notUndefined);
  }
}
